import { createSelector } from 'reselect';

import _has from 'lodash/has';
import _isEmpty from 'lodash/isEmpty';
import _filter from 'lodash/filter';
import _map from 'lodash/map';
import _range from 'lodash/range';
import _toString from 'lodash/toString';
import _findIndex from 'lodash/findIndex';

import { getRule } from 'store/services/rules/selectors';

export const getRuleGroupsAll = ({ ruleGroups }) => ruleGroups.all.data;

export const getIsLoadingAll = ({ ruleGroups }) => ruleGroups.all.isLoading;

export const getRuleGroupsAllCount = ({ ruleGroups }) => ruleGroups.all.count;

export const getRuleGroupsListTotalCount = ({ ruleGroups }) =>
  ruleGroups.list.totalCount;

export const getRuleGroupsList = ({ ruleGroups }) => ruleGroups.list.data.items;

export const getFullRuleGroupsList = ({ ruleGroups }) => ruleGroups.full.data;

export const getRuleGroupsListCount = ({ ruleGroups }) =>
  ruleGroups.list.data.count;

export const getIsLoadingList = ({ ruleGroups }) => ruleGroups.list.isLoading;

export const getRuleGroup = ({ ruleGroups }) => ruleGroups.show.data;

export const getIsAdding = ({ ruleGroups }) => ruleGroups.add.isLoading;

export const getIsDeleting = ({ ruleGroups }) => ruleGroups.delete.isLoading;

export const getIsUpdating = ({ ruleGroups }) => ruleGroups.update.isLoading;

export const getIsGroupPartialUpdating = ({ ruleGroups }) =>
  ruleGroups.partialUpdate.isLoading;

export const getFilterParams = ({ ruleGroups }) => ruleGroups.list.filterParams;

export const getRuleGroupsEnabled = createSelector(
  getRuleGroup,
  group =>
    _has(group, 'rules')
      ? group.rules.some(rule => rule.enabled === true)
      : null,
);

export const getRuleGroupsOrderList = createSelector(
  getRuleGroupsListTotalCount,
  count =>
    count > 0
      ? _map(_range(count), val => ({
          order: _toString(val + 1),
          index: +val,
        }))
      : [],
);

export const getRuleGroupsListWithEnabledKey = createSelector(
  getRuleGroupsList,
  list =>
    list.map(group => ({
      ...group,
      enabled: _has(group, 'rules')
        ? group.rules.some(rule => rule.enabled === true)
        : group.enabled,
    })),
);

export const getRuleIsGrouped = createSelector(
  getFullRuleGroupsList,
  getRule,
  (list, rule) => {
    if (!_isEmpty(rule)) {
      return _findIndex(list, { id: rule.rule_group, visible: false }) === -1;
    }
    return false;
  },
);

export const getPaginationOptions = ({ ruleGroups }) =>
  ruleGroups.list.paginationOptions;

export const getFilterOptions = ({ ruleGroups }) =>
  ruleGroups.list.filterOptions;

export const getRulesMatchedListId = createSelector(
  getRuleGroupsList,
  list => _filter(list, 'matchedRows').map(({ id }) => id),
);

export const getHasSelectedRuleGroup = ({ ruleGroups }) =>
  _has(ruleGroups.show.data, 'id');

// should be here since in rules have error
export const getRuleIndex = createSelector(
  getRule,
  getRuleGroup,
  getRuleGroupsList,
  getHasSelectedRuleGroup,
  (item, group, list) => {
    if (_isEmpty(item) && _isEmpty(group)) {
      return 0;
    }

    const index = _findIndex(list, {
      id: _isEmpty(group) ? item.id : group.id,
    });

    if (index === -1) {
      return _findIndex(list, { id: item.rule_group });
    }

    return index;
  },
);

export const getFilterOptionsWithSelected = createSelector(
  getFilterOptions,
  getPaginationOptions,
  (filterOptions, paginationOptions) =>
    filterOptions.map(option => ({
      ...option,
      selected: option.archived === paginationOptions.archived,
    })),
);

export const getSelectedFilteredOption = createSelector(
  getFilterOptionsWithSelected,
  filterOptions => filterOptions.find(({ selected }) => selected === true),
);
